import { ReactSVG } from "react-svg";

interface IconComponentProps {
  iconPath: string;
  className: string;
}

export const IconComponent: React.FC<IconComponentProps> = ({
  iconPath,
  className,
}) => {
  return (
    <ReactSVG
      src={iconPath}
      className={className}
      beforeInjection={(svg) => {
        svg.setAttribute("width", "1em");
        svg.setAttribute("height", "1em");
      }}
    />
  );
};
